import { PageLoader } from '@/components/PageLoader'
import { usePipelines } from '@/hooks/queries/usePipelines'
import { createFileRoute } from '@tanstack/react-router'
import { formatDistanceToNow } from 'date-fns'
import { Fragment } from 'react/jsx-runtime'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/_modules/_app/processes/pipelines/')({
  component: Pipelines,
})

function Pipelines() {
  const { t } = useTranslation('common')
  const { isPending, error, data: pipelines } = usePipelines()

  if (isPending) return <PageLoader />

  if (error) return t('pipelines.error', { message: error.message })

  type Pipeline = (typeof pipelines)[0]

  const pipelineTypes = pipelines.reduce((acc: Record<string, Pipeline[]>, pipeline) => {
    if (!acc[pipeline.type]) {
      acc[pipeline.type] = []
    }
    acc[pipeline.type].push(pipeline)
    return acc
  }, {})

  return (
    <Fragment>
      {Object.entries(pipelineTypes).map(([type, pipelinesByType]) => (
        <div key={type}>
          <h2>{type}</h2>
          <table>
            <tbody>
              {pipelinesByType.map((pipeline, i) => (
                <tr key={i}>
                  <td>{pipeline.state}</td>
                  <td>{pipeline.name}</td>
                  <td>
                    {pipeline.state === 'Running'
                      ? t('pipelines.isRunning')
                      : formatDistanceToNow(pipeline.lastRun, {
                          addSuffix: true,
                        })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </Fragment>
  )
}
